import {createRouter, createWebHashHistory} from 'vue-router';
import Home from '../views/page/Home.vue';
import List from '../views/page/List.vue';
import Xiaohua from '../views/page/Xiaohua.vue';
import Row from '../views/page/Row.vue';
const routes = [
    {
        path: '/',
        name: 'home',
        component: Home,
    },
    {
        path: '/list/:id',
        name: 'list',
        component: List,
    },
    {
        path: '/Xiaohua',
        name: 'xiaohua',
        component: Xiaohua,
    },
    {
        path: '/row/:id',
        name: 'row',
        component: Row,
    },
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
});

export default router;